import React, {useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";
import {Box, CircularProgress, Tab, Tabs} from "@mui/material";
import {useQuery} from "@apollo/client";
import {GET_NOTIFICATION_CATEGORIES} from "../../graphql/notificationCenterQueries";
import {useSidebarData} from "../sidebar/Context/SidebarProvider";
import StyledBadge from "../badges/StyledBadge";
import NotificationList from "./NotificationList";
import {capitalizeText} from "../../resources/utils/stringUtils";
import {map} from "underscore";

const NotificationTabs = ({onClose, onCategoryVisited}) => {
  const {data, loading} = useQuery(GET_NOTIFICATION_CATEGORIES);
  const {unseenNotificationCounts, resetUnseenCounts} = useSidebarData();
  const [activeTab, setActiveTab] = useState(0);

  const categories = useMemo(() => data?.notificationCategories || [], [data]);

  // Report initial category once categories load
  useEffect(() => {
    if (categories.length > 0) {
      onCategoryVisited(categories[0]);
    }
  }, [categories, onCategoryVisited]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" flex={1} overflow="hidden">
      <Tabs
        value={activeTab}
        onChange={(_, val) => {
          setActiveTab(val);
          onCategoryVisited(categories[val]);
        }}
        variant="fullWidth"
      >
        {map(categories, (cat, index) => (
          <Tab
            key={cat}
            onClick={() => {
              if (index === activeTab) {
                resetUnseenCounts(cat);
              }
            }}
            label={(
              <StyledBadge badgeContent={unseenNotificationCounts[cat] || 0} padParent={2}>
                {capitalizeText(cat)}
              </StyledBadge>
            )}
          />
        ))}
      </Tabs>
      <NotificationList category={categories[activeTab]} onClose={onClose} />
    </Box>
  );
};

NotificationTabs.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCategoryVisited: PropTypes.func.isRequired,
};

export default NotificationTabs;
